import type { OnFileValidation, UUID } from '@pixum/types';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

export function onFileValidation(updater: ImageStateUpdater): OnFileValidation {
  return (uuid: UUID, file: File, clientFileId: UUID) =>
    updater.changeUuid({
      clientFileId,
      uploadId: uuid,
      file,
    });
}
